<template>
  <transition name="fade" mode="out-in">
    <component
      :is="identifierComponentLookUp"
      :user-study-identifier="userStudyIdentifier"
      :user-study-gender="userStudyGender"
      @updateConfirmation="updateConfirmationStatus"
      @updateUserStudyIdentifier="updateUserStudyIdentifier"
      @updateUserStudyGender="updateUserStudyGender"/>
  </transition>

</template>

<script>
import IdentifierConfirmation from '../components/study/BaselineConfirmation'
import IdentifierInput from '../components/study/BaselineInput'
export default {
  name: '',
  components: {
    IdentifierConfirmation,
    IdentifierInput
  },
  data () {
    return {
      userStudyIdentifier: null,
      userStudyGender: null,
      showConfirmationScreen: false
    }
  },
  computed: {
    identifierComponentLookUp (){
      switch (this.showConfirmationScreen) {
        case true:
          return IdentifierConfirmation
        case false:
          return IdentifierInput
      }
    }
  },
  methods: {
    updateConfirmationStatus (val) {
      this.showConfirmationScreen = val
    },
    updateUserStudyIdentifier (val) {
      this.userStudyIdentifier = val
    },
    updateUserStudyGender (val) {
      this.userStudyGender = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/StudyIdentifier.vue